<template>
  <div class="course-required-container">
    <div class="info-card">
      <div class="card-header">
        <div class="icon-wrapper">
          <i class="el-icon-reading"></i>
        </div>
        <h2>选课提醒</h2>
        <p class="subtitle">您需要先选择课程才能正常使用系统功能</p>
      </div>

      <div class="content">
        <div class="feature-list">
          <div class="feature-item">
            <i class="el-icon-check"></i>
            <span>选择感兴趣的课程</span>
          </div>
          <div class="feature-item">
            <i class="el-icon-check"></i>
            <span>参与课程学习和讨论</span>
          </div>
          <div class="feature-item">
            <i class="el-icon-check"></i>
            <span>完成作业和考试</span>
          </div>
          <div class="feature-item">
            <i class="el-icon-check"></i>
            <span>查看学习进度和成绩</span>
          </div>
        </div>

        <div class="action-buttons">
          <el-button
            type="primary"
            size="large"
            @click="goToCourseSelection"
            class="primary-btn"
          >
            立即选课
          </el-button>
          <el-button
            size="large"
            @click="goToHome"
            class="secondary-btn"
          >
            暂不选课
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updateUserStatus } from '@/utils/userStatus'

export default {
  name: 'CourseRequired',
  methods: {
    goToCourseSelection() {
      this.$router.push('/subject-select')
    },
    goToHome() {
      // 设置用户跳过选课状态
      updateUserStatus('skipCourseSelection', true)
      this.$router.push('/index')
    }
  }
}
</script>

<style lang="scss" scoped>
.course-required-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.info-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 100%;
  max-width: 600px;
  text-align: center;
}

.card-header {
  margin-bottom: 30px;

  .icon-wrapper {
    margin-bottom: 20px;

    i {
      font-size: 60px;
      color: #409eff;
    }
  }

  h2 {
    color: #333;
    margin-bottom: 15px;
    font-size: 28px;
  }

  .subtitle {
    color: #666;
    font-size: 16px;
    margin: 0;
    line-height: 1.5;
  }
}

.content {
  .feature-list {
    margin-bottom: 30px;

    .feature-item {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 15px;

      i {
        color: #67c23a;
        margin-right: 10px;
        font-size: 18px;
      }

      span {
        color: #333;
        font-size: 16px;
      }
    }
  }

  .action-buttons {
    display: flex;
    flex-direction: column;
    gap: 15px;

    .primary-btn {
      height: 48px;
      font-size: 16px;
      font-weight: 500;
    }

    .secondary-btn {
      height: 48px;
      font-size: 16px;
      border-color: #dcdfe6;
      color: #606266;

      &:hover {
        border-color: #409eff;
        color: #409eff;
      }
    }
  }
}
</style>
